import { useSelector, useDispatch } from 'react-redux';
import { types } from '@airasia-hotels/core/redux/user/user.meta';

const AA_TOKENS = 'aa_tokens';
// we dont wanna override the exist auth localstorage tokens
const AA_REFRESH_TOKENS = 'aa_refresh_tokens';

const getUserProfile = ({ user }) => user;

export const setSSORefreshAccessTokenInfo = newTokens => {
  localStorage.setItem(AA_REFRESH_TOKENS, JSON.stringify(newTokens));
};

export const getSSORefreshAccessToken = () => {
  const aaTokens = localStorage.getItem(AA_REFRESH_TOKENS);
  return aaTokens && JSON.parse(aaTokens);
};

export const getSSOInfo = () => {
  const aaTokens = localStorage.getItem(AA_TOKENS);
  return aaTokens && JSON.parse(aaTokens);
};

export const useCredential = () => {
  const aaTokens = getSSOInfo();
  const userProfile = useSelector(getUserProfile);
  const dispatch = useDispatch();
  if (!aaTokens && Boolean(userProfile) && userProfile.status) {
    dispatch({ type: types.LOG_OUT });
    return null;
  }
  return userProfile;
};
